import React, { useEffect } from "react";
import "./Gallery.css";
import Nav from "../components/Nav";
import { Footer } from "../components/footer";
import Scrolltop from "../components/Scrolltop";
import { Upperbox } from "../components/Upperbox";

// Image imports
import img1 from "../images/Biriyanis.jpg";
import img2 from "../images/Panner.jpg";
import img3 from "../images/Nonveg_Breakfast.jpg";
import img4 from "../images/starters.jpg";
import img5 from "../images/snacks.jpg";
import img6 from "../images/Tandooris.jpg";
import img7 from "../images/Grilled.jpg";
import img8 from "../images/naan.jpg";
import img9 from "../images/Desserts.jpg";


const Gallery = () => {
  const eventlistimages = [
    { src: img1, title: "Biryani Bliss – A Royal Feast" },
    { src: img2, title: "Paneer Paradise – Soft, Spiced, and Scrumptious" },
    { src: img3, title: "Meaty Mornings – Non-Veg Breakfast Done Right" },
    { src: img4, title: "Starter Sensations – Begin with a Bang!" },
    { src: img5, title: "Street Bites – India on a Plate" },
    { src: img6, title: "Tandoori Temptations – Fire-Kissed Goodness" },
    { src: img7, title: "Grill Thrill – Perfectly Charred Delights" },
    { src: img8, title: "Naan Stop Cravings – Soft, Buttery, Irresistible" },
    { src: img9, title: "Sweet Endings – Because Dessert is a Must!" },
    
    
  ];

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Upperbox />
      <Nav />

      <div className="ps-main">
        <div className="ps-body-part4">
          <div>
            <h1 className="business-section-title" data-aos="fade-down">
              A Sneak Peek at the Best of Our Cuisines
            </h1>
          </div>
          <div className="ps-slider-container">
            <div className="ps-slider-content">
              {eventlistimages.map((card, index) => (
                <div key={index} className="ps-card">
                  <img
                    src={card.src}
                    alt={card.title}
                    className="ps-card-imgages"
                  />
                  <div className="ps-overlay">
                    <h3 className="ps-overlay-title">{card.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Scrolltop />
      <Footer />
    </div>
  );
};

export default Gallery;
